import { Component, AfterViewInit, Input, ChangeDetectionStrategy, ChangeDetectorRef, ViewRef, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FormFunctions } from '../form-functions';
import { ContactInfoCommonCoreFunctions } from './contact-info-common-core.function';
import { Store, select } from '@ngrx/store';
import * as fromApp from 'src/app/store';
import { environment } from '../../../../environments/environment';
import { CommonFunctions } from '../../common/common-functions';
// Please keep this for corporation only
declare namespace pca {
  export enum fieldMode {
    SEARCH,
    POPULATE,
    COUNTRY
  }
  class Address {
    constructor(fields:any, options: any);
    listen(eventType: string, callback: (control: any) => void): void;
  }
}

@Component({
  selector: 'app-contact-info-common-core',
  templateUrl: './contact-info-common-core.component.html',
  styleUrls: ['./contact-info-common-core.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ContactInfoCommonCoreComponent implements AfterViewInit, OnDestroy {
  @Input() formGroup?: UntypedFormGroup;
  @Input() propertyId?: string;
  @Input() relationshipData?: [];
  @Input() addressTypesData?: [];  
  @Input() firmType?: string;
  @Input() firmTypeRelationshipTitle?: string;
  subscriptions: Subscription[] = [];

  regular  = true;
  addressLabel: string = "Address line 1";
  otherLabel: string = "Please describe your relationship to the business";
  otherTypeCode: string = 'o';
  ownerOrShareholderTypeCode: string = 'sh';
  internetRegistration: any;

  constructor(private store$: Store<fromApp.State.State>, 
    private cd: ChangeDetectorRef, 
    public formFunctions: FormFunctions, 
    private commonFunctions: CommonFunctions, 
    private contactInfoCommonCoreFunctions: ContactInfoCommonCoreFunctions) { }

  ngAfterViewInit(): void {
    this.subscriptions.push(
      this.store$.pipe(select(fromApp.Selectors.getInternetRegistration)).subscribe(
        iReg => {     
           // this code will be triggered more than once
          this.internetRegistration = iReg;          
        },
      )
    );
    this.initializeAddressAutocomplete();
    this.detectChanges();
  }
  
  addNewFields(event:any){
    this.contactInfoCommonCoreFunctions.addNewFields(event, this.formGroup, this.internetRegistration);
    this.detectChanges();
  }  

  private unsubscribeAll() {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
  }
 	
  ngOnDestroy() {
    this.unsubscribeAll();
  } 
  
  private detectChanges() {
    // Programmatically run change detection to fix issue in Safari
    setTimeout(() => {
      if ( this.cd !== null &&
          this.cd !== undefined &&
          ! (this.cd as ViewRef).destroyed ) {
              this.cd.detectChanges();
      }
    }, 250);
  }

  initializeAddressAutocomplete(): void {
    try {
      const fields = [{ element: "search", field: "", mode: pca.fieldMode.SEARCH }];
      const options = { key: environment.canadaPostAddressCompleteId, countries: { codesList: "USA,CAN" }, setCountryByIP: true, };
      const control = new pca.Address(fields, options);
      control.listen('populate', (address: any) => {
          if (address) {
            this.formGroup.get('addressLine1').setValue(this.commonFunctions.languageFilter(address.Line1) || '');
            this.formGroup.get('addressLine2').setValue(this.commonFunctions.languageFilter(address.Line2) || '');
            this.formGroup.get('city').setValue(this.commonFunctions.languageFilter(address.City) || '');
            this.formGroup.get('postalCode').setValue(this.commonFunctions.languageFilter(address.PostalCode) || '');
            this.formGroup.get('province').setValue(this.commonFunctions.languageFilter(address.ProvinceCode) || '');
            this.formGroup.get('state').setValue(this.commonFunctions.languageFilter(address.ProvinceCode) || ''); //for US
            this.formGroup.get('country').setValue(this.commonFunctions.languageFilter(address.CountryIso2) || '');

            let control = this.formGroup.get('addressLine1');
            if (control) {
              control.updateValueAndValidity();
            } 
          }
        });
      } catch (ex) {
      console.log('ContactInfoCommonCoreComponent-initializeAddressAutocomplete ex=' + ex.message);
    }  
    
  }
}
